import styled from 'styled-components';

export const DotBadge = () => {
  return (
    <DotWrapper>
      <Dot />
    </DotWrapper>
  );
};

const DotWrapper = styled.div`
  position: relative;
  width: 100%;
`;

const Dot = styled.span`
  position: absolute;
  top: -3px;
  right: 0px;

  display: block;

  width: 8px;
  height: 8px;
  border-radius: var(--radius-medium, 8px);
  background-color: #ff3049;
`;
